<template>
  <v-form v-model="valid" ref="form">
    <v-card class="container">
      <v-card-title class="pt-0">
        <span class="headline">{{$t('general_information')}}</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-row align="center">
              <v-divider></v-divider>
              <v-btn plain disabled>{{$t('personal')}}</v-btn>
              <v-divider></v-divider>
            </v-row>
          </v-col>
          <v-col md="12" class="pb-0 pt-0">
            <v-text-field
              label="KTP"
              v-model="formData.ktpNumber"
              :rules="[numberNotRequired]"
              type="text"
            ></v-text-field>
          </v-col>
          <v-col md="12" class="pb-0 pt-0">
            <v-text-field
              :label="$t('full_name')"
              v-model="formData.officialName"
              type="text"
              :rules="[...rules, validator.alfaForName] "
              required
              class="sae-required"
            ></v-text-field>
          </v-col>
          <v-col md="12" class="pb-0 pt-0">
            <v-text-field
              label="Fingerprint ID"
              v-model="formData.fingerprint"
              type="text"
              :rules="[validator.alfaForID] "
              required
            ></v-text-field>
          </v-col>
          <v-col md="12" class="pb-0 pt-0">
            <v-text-field
              :label="$t('email')"
              @keydown.space.prevent
              @input="removeSpace(formData.email, 'email')"
              v-model="formData.email"
              type="email"
              :rules="[...emailRules,validator.email]"
              required
              class="sae-required"
            ></v-text-field>
          </v-col>
          <v-col md="12" class="pb-0 pt-0">
            <v-text-field
              :label="$t('phoneNumber')"
              v-model="formData.phoneNumber"
              type="text"
              :rules=" payrollEnabled ? [...rules4,validator.alfaNumberNotRequired] : []"
              :class="{'sae-required': payrollEnabled}"
            ></v-text-field>
          </v-col>
          <v-col md="6" class="pb-0 pt-0">
            <v-text-field 
              :label="$t('placeOfBirth')"
              v-model="formData.placeOfBirth" 
              type="text"
              :rules=" payrollEnabled ? [...rules, validator.alfaNumberNotRequired] : []"
              :class="{'sae-required': payrollEnabled}"
            ></v-text-field>
          </v-col>
          <v-col md="6" class="pb-0 pt-0">
            <v-menu
              ref="menu"
              v-model="menuStart"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="dateFormatted(formData.dateOfBirth)"
                 :label="$t('dateOfBirth')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                  color="primary"
                  required
                  class="sae-required"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="formData.dateOfBirth"
                @change="onStartDateChange"
                no-title
                :max="todayDate"
                scrollable
                :locale="$t('locale')"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col md="12" class="pb-0 pt-0">
            <v-select
               :label="$t('gender')"
              v-model="formData.gender"
              :items="genderList"
              item-text="nameId"
              item-value="id"
              :rules=" payrollEnabled ? rules2 : []"
              :class="{'sae-required': payrollEnabled}"
            ></v-select>
          </v-col>

          <v-col md="12" class="pb-0 pt-0">
            <v-select
              :label="$t('religion')"
              v-model="formData.religion"
              :items="religionList"
              item-text="nameId"
              item-value="id"
              :rules=" payrollEnabled ? rules2 : []"
              :class="{'sae-required': payrollEnabled}"
            ></v-select>
          </v-col>
          <v-col md="12" class="pb-0 pt-0">
            <v-select
               :label="$t('maritalStatus')"
              v-model="formData.maritalStatus"
              :items="maritalList"
              item-text="nameId"
              item-value="id"
              :rules=" payrollEnabled ? rules2 : []"
              :class="{'sae-required': payrollEnabled}"
            ></v-select>
          </v-col>

          <v-col md="12" class="pb-0 pt-0">
            <v-select
              :items="countryList"
               :label="$t('citizenship')"
              v-model="formData.citizenship"
              type="text"
              item-text="name"
              item-value="id"
              :rules=" payrollEnabled ? rules5 : []"
              :class="{'sae-required': payrollEnabled}"
            ></v-select>
          </v-col>

          <v-col cols="12">
            <v-row align="center">
              <v-divider></v-divider>
              <v-btn plain disabled>{{$t('work')}}</v-btn>
              <v-divider></v-divider>
            </v-row>
          </v-col>
          <v-col md="12" class="pb-0 pt-0">
            <v-text-field
               :label="$t('employee_id')"
              @input="removeSpace(formData.employeeId, 'employeeId')"
              v-model="formData.employeeId"
              type="text"
              @keydown.space.prevent
              :rules="[...rules, validator.alfaForID]"
              required
              class="sae-required"
            ></v-text-field>
          </v-col>
          <v-col md="12" class="pb-0 pt-0">
            <v-text-field
              label="NPWP"
              v-model="formData.npwpNumber"
              :rules="[numberNotRequired]"
              type="text"
            ></v-text-field>
          </v-col>
          <v-col md="12" class="pb-0 pt-0">
            <v-autocomplete
              v-model="formData.groupId"
              :items="groupListSelection"
              hide-no-data
              hide-selected
              item-text="alias"
              item-value="id"
              :label="$t('group')"
              :rules="rules2"
              required
              class="sae-required"
            ></v-autocomplete>
            <span v-if="formData.groupId" style="color: #E64A4D; font-size: 12px;">
            {{ $t('group_change_warning_1') }}<br>
            {{ $t('group_change_warning_2') }}
            </span>
          </v-col>
          <v-col md="12" class="pb-0 pt-0">
            <v-select
              :label="$t('position')"
              v-model="formData.positionName"
              :items="positionList"
              item-text="name"
              item-value="id"
              :rules="rules2"
              required
              class="sae-required"
            ></v-select>
          </v-col>

          <v-col md="12" class="pb-0 pt-0">
            <v-text-field :rules="[validator.titleRequired]" :label="$t('position_title')" v-model="formData.currentPosition" type="text"></v-text-field>
          </v-col>
          <v-col md="6" class="pb-0 pt-0">
            <v-menu
              ref="menu"
              v-model="menuJoin"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="dateFormatted(formData.joinDate)"
                  :label="$t('joinDate')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                  color="primary"
                  required
                  class="sae-required"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="formData.joinDate"
                @change="onJoinDateChange"
                :max="todayDate"
                no-title
                scrollable
                :locale="$t('locale')"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col md="6" class="pb-0 pt-0">
            <v-select
              :label="$t('workingStatus')"
              v-model="formData.workingStatus"
              :items="workingStatusList"
              item-text="nameId"
              item-value="id"
              :rules=" payrollEnabled ? rules2 : []"
              :class="{'sae-required': payrollEnabled}"
            ></v-select>
          </v-col>
          <v-col cols="12" v-if="isEdit">
            <v-row>
              <v-col cols="12" v-if="formData.directSupervisor.length != 0">
                <v-row align="center">
                  <v-divider></v-divider>
                  <v-btn plain disabled>Supervisor</v-btn>
                  <v-divider></v-divider>
                </v-row>
              </v-col>
              <v-col
                md="6"
                class="pb-0 pt-0"
                v-for="(item,i) in formData.directSupervisor"
                v-bind:key="`${i}sup`"
              >
                <v-text-field
                  :label="`Supervisor ${formData.directSupervisor.length != 1 ? i+1 :'' }`"
                  v-model="item.full_name"
                  type="text"
                  readonly
                  :rules="rules"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col md="12" v-if="isEdit">
            <v-row>
              <v-col cols="12" v-if="formData.workLocation.length != 0">
                <v-row align="center">
                  <v-divider></v-divider>
                  <v-btn plain disabled>{{$t('work_location')}}</v-btn>
                  <v-divider></v-divider>
                </v-row>
              </v-col>
              <v-col
                md="6"
                class="pb-0 pt-0"
                v-for="(item,i) in formData.workLocation"
                v-bind:key="`${i}wor`"
              >
                <v-text-field
                  :label="`${$t('work_location')} ${formData.workLocation.length != 1 ? i+1 :'' }`"
                  v-model="item.zoneName"
                  type="text"
                  readonly
                  :rules="rules"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col md="12">
            <v-row>
              <v-col cols="12">
                <v-row align="center">
                  <v-divider></v-divider>
                  <v-btn plain disabled>{{$t('others')}}</v-btn>
                  <v-divider></v-divider>
                </v-row>
              </v-col>
              <!-- <v-col md="6" class="pb-0 pt-0">
                <v-select
                   :label="$t('status')"
                  v-model="formData.status"
                  :rules="rules"
                  :items="statusList"
                  item-text="name"
                  item-value="id"
                  requried
                  class="sae-required"
                ></v-select>
              </v-col> -->
              <v-col md="6" class="pb-0 pt-0">
                <v-menu
                  ref="menu"
                  v-model="menuResign"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="dateFormatted(formData.resignationDate)"
                       :label="$t('resignationDate')"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                      color="primary"
                      clearable
                      @click:clear="formData.resignationDate = null" 
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="formData.resignationDate"
                    @change="onResignDateChange"
                    :min="formData.joinDate"
                    no-title
                    scrollable
                    :locale="$t('locale')"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="6" class="pb-0 pt-0">
                <v-select
                  :items="accessType"
                   :label="$t('access_type')"
                  v-model="formData.userAccess"
                  item-text="name"
                  item-value="id"
                  :rules="rules2"
                  @change="changeUserRole"
                  required
                  class="sae-required"
                ></v-select>
              </v-col>
              <v-col cols="6" v-show="userAbility.length > 0">
                <v-alert outlined>
                  <!-- <p class="overline mb-2">Mobile Only</p> -->
                  <div class="caption">{{ userAbility }}</div>
                </v-alert>
              </v-col>
            </v-row>
          </v-col>

          <v-col md="12" class="text-center">
            <v-btn @click="backFunction" v-if="!isEdit" plain class="ma-2 primary--text">{{$t('cancel')}}</v-btn>
            <v-btn
              color="primary"
              class="ma-2"
              :disabled="!valid"
              :loading="loading"
              @click="saveOrUpdate(formData)"
            >{{$t('save')}}</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-form>
</template>

<script>
import moment from 'moment'

export default {
  props: ['userId', 'employeeInformation', 'groupListSelection', 'payrollEnabled'],
  name: "Employee-Information",
  data() {
    return {
      rules: [(value) => (value === 0 ? true : !!value || this.$i18n.t('required'))],
      rules2: [(value) => (value == 0 ? true : value ? value > 0 : !!value || this.$i18n.t('required'))],
      rules4: [
        v => /^[0-9]+$/.test(v) || this.$i18n.t('number_required'),
        (value) => (value === 0 ? true : !!value || this.$i18n.t('required'))
      ],
      rules5: [(value) => (value ? value.length == 0 ? false || this.$i18n.t('required') : true : false || this.$i18n.t('required'))],
      emailRules: [
        (v) => !!v || this.$i18n.t('required'),
        (v) => /.+@.+\..+/.test(v) || this.$i18n.t('email_required'),
      ],
      numberNotRequired: v  => {
        if (v) { if (!v.trim()) return true; } 
        else { return true; }
        if (/^[0-9 .,-]+$/.test(v)) return true;
        return this.$i18n.t('number_required');
      },
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      valid: false,
      accessType: [
        { id: 0, name: 'Admin HRD' },
        { id: 1, name: 'Staff' },
        // { id: 2, name: 'Admin Appsensi' },
        { id: 3, name: 'Supervisor' },
        { id: 4, name: 'Executive' },
      ],
      formData: {
        dateOfBirth: moment().locale(this.$i18n.t('lang')).format('YYYY-MM-DD')
      },
      userIdLogin: this.$store.getters.user.id,
      isEdit: false,
      loading: false,
      menuStart: false,
      userAbility: '',
      genderList: [],
      maritalList: [],
      workingStatusList: [],
      religionList: [],
      positionList: [],
      statusList: [
        { id: 0, name: this.$i18n.t('not_active') },
        { id: 1, name: this.$i18n.t('active') },
      ],
      countryList: [],
      menuJoin: false,
      menuResign: false,
      todayDate: moment().locale(this.$i18n.t('lang')).format('YYYY-MM-DD')
    }
  },
  methods: {
    backFunction() {
      this.$emit('close', true)
    },
    removeSpace(input, type) {
      if(type == 'email'){
        this.formData.email = 
        input.replace(/ /g,'');
      }else if (type == 'employeeId'){
         this.formData.employeeId = 
        input.replace(/ /g,'');
      }
    },
    dateFormatted(date) {
      if (date) return moment(date).locale(this.$i18n.t('lang')).format('Do MMMM YYYY');
      return null
    },
    onStartDateChange() {
      this.menuStart = false;
    },
    onJoinDateChange() {
      const joinDate = moment(this.formData.joinDate)
      const resignDate = moment(this.formData.resignationDate)
      const diff = moment(joinDate).diff(resignDate, 'day')
      if (diff > 0) { this.formData.resignationDate = this.formData.joinDate }
      this.menuJoin = false;
    },
    onResignDateChange() {
      this.menuResign = false;
    },
    costumHeader(actionId, action) {
      return { headers: { actionId, action } }
    },
    formatTime(date) {
      return moment(date).locale(this.$i18n.t('lang')).format("Do MMMM YYYY")
    },
    async getGender() {
      this.loading = true
      this.genderList = await this.$store.dispatch('getGender')
      this.loading = false
    },
    async getMarital() {
      this.loading = true
      this.maritalList = await this.$store.dispatch('getMarital')
      this.loading = false
    },
    async getWorkingStatus() {
      this.loading = true
      this.workingStatusList = await this.$store.dispatch('getEmployeeWorkingStatus')
      this.loading = false
    },
    async getReligion() {
      this.loading = true
      this.religionList = await this.$store.dispatch('getReligion')
      this.loading = false
    },
    async getCountry() {
      this.loading = true
      this.countryList = await this.$store.dispatch('getCountry')
      this.loading = false
    },
    async getPosition() {
      this.loading = true
      this.positionList = await this.$store.dispatch('getPositions')
      this.loading = false
    },
    async saveOrUpdate(data) {
      if (this.isEdit) {
        this.editComponent(data)
      } else {
        this.saveComponent(data)
      }
    },
    async saveComponent(data) {
      const body = {
        ...data,
        gender_id: data.gender,
        date_of_birth: data.dateOfBirth,
        religion_id: data.religion,
        fingerprint: data.fingerprint,
        marital_status_id: data.maritalStatus,
        working_status_id: data.workingStatus,
        phone_number: data.phoneNumber,
        job_position: data.currentPosition,
        employee_code: data.employeeId,
        position_id: data.positionName,
        positionId: data.positionName,
        full_name: data.officialName,
        place_of_birth: data.placeOfBirth,
        role: data.userAccess,
        join_date: data.joinDate,
        npwp_number: data.npwpNumber,
        ktp_number: data.ktpNumber,
        resignation_date: data.resignationDate,
      }
      this.loading = true
      const result = await this.$store.dispatch('saveEmployeeInformation', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.$emit('close', true)
        this.tab = 0
      }
    },
    async editComponent(data) {
      const body = {
        ...data,
        id: this.userId,
        gender_id: data.gender,
        date_of_birth: data.dateOfBirth,
        fingerprint: data.fingerprint,
        religion_id: data.religion,
        marital_status_id: data.maritalStatus,
        working_status_id: data.workingStatus,
        phone_number: data.phoneNumber,
        job_position: data.currentPosition,
        employee_code: data.employeeId,
        position_id: data.positionName,
        positionId: data.positionName,
        full_name: data.officialName,
        place_of_birth: data.placeOfBirth,
        role: data.userAccess,
        join_date: data.joinDate,
        npwp_number: data.npwpNumber,
        ktp_number: data.ktpNumber,
        resignation_date: data.resignationDate,
      }
      // // eslint-disable-next-line no-console
      // console.log(body, 'body')
      delete body.directSupervisor
      delete body.workLocation
      this.loading = true
      const result = await this.$store.dispatch('editEmployeeInformation', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.$emit('reload', true)
        this.tab = 0
      }
    },
    changeUserRole(role) {
      switch (role) {
        case 0:
          this.userAbility =
            "Access all menus in the web application dashboard and view the reports of all employees.";
          break;
        case 1:
          this.userAbility =
            "Can only access the mobile application (Can’t access web dashboard).";
          break;
        case 3:
          this.userAbility =
            "Can only access the report and view the data reports belonging to each group’s corresponding hierarchy.";
          break;
        case 4:
          this.userAbility =
            "Can only access the report and view the data of all employees.";
          break;
        default:
          this.userAbility = ''
          break
      }
    },
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', {type,msg})
    },
    refreshData() {
      if (this.employeeInformation) {
        this.formData = Object.assign({ full_name: '' }, this.employeeInformation)
        this.formData.gender = this.formData.genderId
        this.formData.maritalStatus = this.formData.maritalStatusId
        this.formData.fingerprint = this.formData.fingerprint
        this.formData.workingStatus = this.formData.workingStatusId
        this.formData.religion = this.formData.religionId
        this.formData.positionName = this.formData.positionId
        this.formData.group = this.formData.groupId
        this.formData.accessType = this.formData.role
        this.formData.ktpNumber = this.formData.ktp_number
        this.formData.npwpNumber = this.formData.npwp_number
        
        this.changeUserRole(this.formData.role)
        this.isEdit = true
        if (this.employeeInformation.dateOfBirth) {
          this.formData.dateOfBirth = moment(this.employeeInformation.dateOfBirth).locale(this.$i18n.t('lang')).format('YYYY-MM-DD')
        } else {
          this.formData.dateOfBirth = null
        }
        if (this.employeeInformation.joinDate) {
          this.formData.joinDate = moment(this.employeeInformation.joinDate).locale(this.$i18n.t('lang')).format('YYYY-MM-DD')
        } else {
          this.formData.joinDate = null
        }
      } else {
        if (this.$refs.form && !this.isEdit) {
          this.$refs.form.reset();
        }
        this.formData = { full_name: '', dateOfBirth: null }
        this.isEdit = false
      }
    },
  },
  created() {
    this.refreshData()
    this.getGender()
    this.getMarital()
    this.getWorkingStatus()
    this.getReligion()
    this.getPosition()
    this.getCountry()
  },
  watch: {
    employeeInformation() {
      this.refreshData()
    },
    userId() {
      this.refreshData()
    },
  }
}
</script>
